"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.essDocumentTypesFactory = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const dictionary_evidence_1 = require("../../../../composite/evidence/dictionary-evidence/dictionary-evidence");
const evidence_1 = require("../../../../composite/evidence/evidence");
function essDocumentTypesFactory(url, reportTag) {
    return function DocumentTypes() {
        const intl = react_intl_1.useIntl();
        const evidence = dictionary_evidence_1.useDictionaryEvidence({
            identifier: 'ESS_DOCUMENT_TYPES',
            apiProps: {
                url,
            },
            tableProps: {
                tableName: intl.formatMessage({
                    id: 'ESS_RECORDS_TABLE_TITLE',
                    defaultMessage: 'Typy dokumentů',
                }),
                reportTag,
            },
            detailProps: {},
        });
        return react_1.default.createElement(evidence_1.Evidence, Object.assign({}, evidence));
    };
}
exports.essDocumentTypesFactory = essDocumentTypesFactory;
//# sourceMappingURL=document-types.js.map